import React, { FC, useCallback, useMemo, useState } from "react";
import { CaptionLabelProps } from "react-day-picker";

import { format, getMonth, getYear } from "date-fns";

import {
  StyledMonth,
  StyledMonths,
  StyledYearMonthPicker,
  StyledYearMonthPickerNavBar,
  StyledYearMonthPickerNavBarItem,
} from "./Styles";

interface IYearMonthForm {
  onChange?: (modifiersArg) => void;
  isShown?: boolean;
  text: string;
  selectedDays?: { from; to } | Date;
  selectionMode?: string;
  month: Date;
  onClick: (e) => void;
}

export const YearMonthPicker: FC<CaptionLabelProps & IYearMonthForm> = ({
  month,
  onChange = (): null => null,
  isShown = true,
  onClick,
  text,
  selectedDays,
  selectionMode,
}) => {
  const [enteredTo, setEnteredTo] = useState<number | undefined>();
  const currentYear = getYear(new Date());
  const months = Array.from({ length: 12 }, (_, i) =>
    format(new Date(currentYear, i, 1), "MMMM")
  );

  const handleMonthChange = useCallback(
    (e) => {
      onChange(new Date(getYear(month), e.target.dataset.value));
      if (onClick) {
        onClick(e);
      }
    },
    [month, onChange, onClick]
  );

  const onMouseEnterCallback = useCallback(
    (e) => {
      if (selectionMode === "quarterly") {
        setEnteredTo(Math.floor(e.target.getAttribute("data-value") / 3));
      }
    },
    [selectionMode]
  );

  const renderMonths = useMemo(() => {
    return (
      <StyledMonths className="c-monthPicker" data-test="months">
        {months.map((singleMonth, i) => {
          return (
            <StyledMonth
              className="c-monthPicker__month"
              key={i}
              onClick={handleMonthChange}
              onMouseEnter={onMouseEnterCallback}
              data-value={i}
              data-test="month"
              $isCurrent={
                month.getFullYear() === new Date().getFullYear() &&
                new Date().getMonth() === i
              }
              $isCurrentQuarter={Math.floor(i / 3) === enteredTo}
              $isSelected={
                selectedDays &&
                !(selectedDays instanceof Date) &&
                selectedDays.from &&
                selectedDays.to &&
                selectedDays.from.getFullYear() === getYear(month) &&
                i >= getMonth(selectedDays.from) &&
                i <= getMonth(selectedDays.to)
              }
            >
              {singleMonth.substring(0, 3)}
            </StyledMonth>
          );
        })}
      </StyledMonths>
    );
  }, [
    months,
    handleMonthChange,
    onMouseEnterCallback,
    enteredTo,
    selectedDays,
    month,
  ]);

  return (
    <StyledYearMonthPicker className="c-DayPicker-Caption" role="button">
      <StyledYearMonthPickerNavBar role="button">
        <StyledYearMonthPickerNavBarItem
          data-test="show-picker"
          onClick={onClick}
        >
          {text}
        </StyledYearMonthPickerNavBarItem>
      </StyledYearMonthPickerNavBar>
      {isShown && renderMonths}
    </StyledYearMonthPicker>
  );
};

YearMonthPicker.displayName = "YearMonthPicker";
